import VerifyInItemReceive from "../../../../components/@documents/item_receives/VerifyInItemReceive";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReceiveVerifyInPage() {

    return (
        <VerifyInItemReceive 
            routeType={routeTypes.retail}
        />
    )
}